import React, { useContext, useEffect, useState } from 'react';
import {
  ExceptionListContainer,
  ExceptionList,
  ExcetionItemCategory,
  ExceptionListTitle,
  ExceptionCheckboxContainer,
  ExceptionCheckboxField,
  ExceptionCheckboxLabel,
  ExceptionSelectedItem,
  ExceptionFormRow,
  ExceptionWrapper
} from './styles';
import { getExceptions, saveException, skipException } from '../../../services/exceptions';
import { distinctByExceptionCategory } from '../../../helpers/distinct';
import { otherCausalIdType } from '../../../helpers/enum';
import colors from '../../../assets/styles/colors';
import { BsCheck } from 'react-icons/bs';
import { ExceptionContext } from "../../../store";
import { default as ExceptionTypes } from "../../../store/Exception/types";
import { IoClose } from 'react-icons/io5';
import { Form, FormFooter } from '../../../components/FormTemplate/styles';
import { useForm, Controller } from 'react-hook-form';
import InputDefault from '../../../components/InputDefault';
import InputDate from '../../../components/InputDate';
import ModalAction from '../../../components/ModalAction';
import Loader from '../../../components/Loader';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { useHistory, useLocation } from 'react-router-dom';

const ExceptionListPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { exception, setException } = useContext(ExceptionContext);
  const { errors, register, handleSubmit, control, watch, setValue } = useForm({ defaultValues: exception });
  const [exceptions, setExceptions] = useState([]);
  const [exceptionsCategories, setExceptionsCategories] = useState([]);
  const [filteredExceptions, setFilteredExceptions] = useState([]);
  const [activeCategory, setActiveCategory] = useState('');
  const [showConformityModal, setShowConformityModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();

  async function initializeStateComponent() {
    try {
      const response = await getExceptions();

      setExceptions(response.data);
      setExceptionsCategories(distinctByExceptionCategory(response.data));
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  async function setCompleteStep() {
    try {
      setIsLoading(true);

      const filteredExceptions = exception.categories.map(item => {
        return {
          idExcepcion: item.id
        }
      })
  
      const data = {
        idCredito: location.idCredit,
        idAsesor: exception.credit.idAsesorPrincipal,
        excepcionesSolicitud: filteredExceptions
      }

      if(exception.categories.filter(item => item.id === otherCausalIdType.id).length) {
        data.observacion = exception.detail;
        data.fechaVencimiento = exception.fechaVencimiento;
      }

      await saveException(data);
      setIsLoading(false);
      setShowConformityModal(true);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
      console.log(error.response)
    }
  }

  function selectCategory(category) {
    setActiveCategory(category);
    setFilteredExceptions(exceptions.filter(item => item.tipo.nombre === category));

    setException({
      type: ExceptionTypes.SET_INPUT_VALUE,
      detail: fields.detail === '' ? exception.detail : fields.detail,
      fechaVencimiento: fields.fechaVencimiento === '' ? exception.fechaVencimiento : fields.fechaVencimiento,
    })
  }

  function setSelectedCategoryByFilter(category) {
    if(exception.categories.indexOf(category) > -1) {
      setException({
        type: ExceptionTypes.SET_CATEGORY,
        category: exception.categories.filter(item => item.id !== category.id),
      })
    } else {
      if(exception.categories.length < 5) {
        setException({
          type: ExceptionTypes.SET_CATEGORY,
          category: [...exception.categories, category],
        })
      }
    }
  }

  async function skipExceptionProcess() {
    try {
      setIsLoading(true);

      const data = {
        idCredito: location.idCredit
      }

      await skipException(data);
      setIsLoading(false);
      history.push({
        pathname: '/admin/ap-secure',
        idCredit: location.idCredit
      })
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(activeCategory === otherCausalIdType.nombre) {
      setValue('detail', exception.detail);
      setValue('fechaVencimiento', exception.fechaVencimiento);
    }
  }, [activeCategory])

  useEffect(() => {
    initializeStateComponent();

    return () => {
      setExceptionsCategories([]);
      setExceptions([]);
      setFilteredExceptions([]);
      setActiveCategory('');
    }
  }, []);

  return (
    <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
      {isLoading && <Loader />}
      <ExceptionWrapper>
        <ExceptionListContainer>
          <ExceptionList>
            {exceptionsCategories.map((item, key) => (
              <ExcetionItemCategory key={key} active={item === activeCategory} onClick={() => selectCategory(item)}>{item}</ExcetionItemCategory>
            ))}
          </ExceptionList>
          <ExceptionList>
            <ExceptionListTitle>{activeCategory}</ExceptionListTitle>
            
            {filteredExceptions.map((item, key) => (
              <ExceptionCheckboxContainer key={key}>
                <ExceptionCheckboxField id="checkbox" checked={exception.categories.indexOf(item)> -1} onClick={() => setSelectedCategoryByFilter(item)}>
                  <BsCheck color={colors.white} id="check-icon" />
                </ExceptionCheckboxField>
                <ExceptionCheckboxLabel>{item.nombre}</ExceptionCheckboxLabel>
              </ExceptionCheckboxContainer>
            ))}

            {exception.categories.filter(item => item.id === otherCausalIdType.id).length && activeCategory === otherCausalIdType.nombre ? (
              <ExceptionFormRow>
                <Controller
                  as={InputDefault}
                  control={control}
                  label="Detalle Excepción (Opcional)"
                  name="detail"
                  register={register}
                  id="detail"
                  error={errors.detail}
                  value={exception.detail} />
                <InputDate
                  aria-required
                  type="date"
                  label="Fecha vencimiento excepciones (Opcional)"
                  name="fechaVencimiento"
                  register={register({ required: "Este dato es obligatorio" })}
                  id="fechaVencimiento"
                  onBlur={() => {}}
                  error={errors.fechaVencimiento} />
              </ExceptionFormRow>
            ) : ''}
          </ExceptionList>
          <ExceptionList>
            <ExceptionListTitle>Excepciones seleccionadas ({exception.categories.length})</ExceptionListTitle>
            {exception.categories.map((item, key) => (
              <ExceptionSelectedItem key={key}>
                {`${key + 1}. ${item.nombre}`}
                <IoClose color={colors.textPrimary} size={22} onClick={() => setSelectedCategoryByFilter(item)} />
              </ExceptionSelectedItem>
            ))}
          </ExceptionList>
        </ExceptionListContainer>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" id="button" onClick={() => skipExceptionProcess()}>Continuar sin excepción</DefaultLargeButton>
          <SecondaryLargeButton type="submit" id="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
      </ExceptionWrapper>
      <ModalAction
        open={showConformityModal}
        actionFunctionDownButton={() => history.push('/admin/dashboard')}
        actionFunctionUpButton={() => history.push('/admin/dashboard')}
        title={"Estamos en proceso de validación"}
        actionLabelFunctionUpButton="Continuar"
        actionLabelFunctionDownButton="Cerrar"
        description={"La solicitudes de exepciones fueron registradas exitosamente, debes estar pendiente de estas en la opción del menú llamada Excepciones."}
        bodyIcon={<BsCheck color={colors.white} size={32} id="check" />}
        backgroundIcon={colors.textHyperlink} />
    </Form>
  )
}

export default ExceptionListPage;
